export const tableContent = [
  {
    heading: [
      {
        column: "Loan Amount (₹)",
      },
      {
        column: "Current Interest Rate (%)",
      },
      {
        column: "New Interest Rate (%)",
      },
      {
        column: "Tenure (Months)",
      },
      {
        column: "Current EMI (₹)",
      },
      {
        column: "New EMI (₹)",
      },
      {
        column: "Monthly Savings (₹)",
      },
      {
        column: "Total Savings (₹)",
      },
    ],
    rowData: [
      {
        amount: "5,00,000",
        interest: "15",
        newInterest: "12",
        Tenure: "36",
        currentEMI: "17,382",
        newEMI: "16,607",
        monthlySaving: "775",
        totalSaving: "27,900",
      },
      {
        amount: "7,00,000",
        interest: "18",
        newInterest: "13",
        Tenure: "48",
        currentEMI: "20,926",
        newEMI: "18,960",
        monthlySaving: "1,966",
        totalSaving: "94,368",
      },
      {
        amount: "10,00,000",
        interest: "14",
        newInterest: "11",
        Tenure: "60",
        currentEMI: "23,268",
        newEMI: "21,739",
        monthlySaving: "1,529",
        totalSaving: "91,740",
      },
    ],
  },
];
